import React from 'react';
import { MedicationRequestOutputDto } from 'graphql/generated/remote-schema-hasura';

const Row: React.FC<{ label: string; value: string | React.ReactNode }> = ({
  label,
  value,
}) => {
  return (
    <div className="flex gap-5 justify-start items-start">
      <div className="min-w-[80px] w-20 justify-start text-charcoal-gray text-sm font-semibold leading-5">
        {label}
      </div>
      <div className="flex-1 text-right justify-start text-med-gray-3 text-sm font-medium leading-5">
        {value}
      </div>
    </div>
  );
};

const MedicationMobile: React.FC<{
  medication: MedicationRequestOutputDto;
  locale: Record<string, string>;
}> = ({ medication, locale }) => {
  return (
    <div className="flex py-5 mx-5 flex-col gap-2.5 border-b border-b-gray-opacity-15 last-of-type:border-b-transparent desktop:hidden">
      <Row
        label={locale.medication}
        value={
          <>
            <p>{medication.displayName}</p>
          </>
        }
      />
      <Row label={locale.dose} value={medication.dosage || '-'} />
      <Row label={locale.frequency} value={medication.frequency || '-'} />
      <Row label={locale.duration} value={medication.duration || '-'} />
      <Row label={locale.takeWith} value={medication.takeWith || '-'} />
      <Row label={locale.notes} value={medication.productNotes || '-'} />
    </div>
  );
};

export default MedicationMobile;
